const Dash = () => '—';

export default Dash;
